// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { Category, } from '@aws-amplify/core/internals/utils';
export const getAuthUserAgentDetails = (action, customUserAgentDetails) => ({
    category: Category.Auth,
    action,
    ...customUserAgentDetails,
});
